export default {
  id: 'deck_nature',
  // card_model: '/3dmodels/cards/08/card.gltf',
  // emissive_color: 0xfd027f,
  emissive_color: '#d1bc00',

  grayValueSplitPoint: '0.0', //will become default in shader
  vertex_shader_front: '/shaders/cardVert.glsl',
  fragment_shader_front: '/shaders/cardFrag.glsl',
  vertex_shader_back: '/shaders/cardVert.glsl',
  fragment_shader_back: '/shaders/cardFrag.glsl',
  cards: [
    {
      "id": "card01",
      "index": 0,
      "y": 0,
      "x": 0,
      "z": 0.03,
      "front": {
        "metalness": "/textures/deck_nature/trust01_rough.png",
        "texture": "/textures/deck_nature/trust01.png",
      },
      "back": {
        "texture": "/textures/deck_nature/backside_01.png",
        "metalness": "/textures/deck_nature/backside_01_rough.png",
      },
      "face_up": false
    },
    {
      "id": "card02",
      "index": 1,
      "y": 0,
      "x": 0,
      "z": 0.03,
      "front": {
        "metalness": "/textures/deck_nature/ego01_rough.png",
        "texture": "/textures/deck_nature/ego01.png"
      },
      "back": {
        "texture": "/textures/deck_nature/backside_01.png",
        "metalness": "/textures/deck_nature/backside_01_rough.png",
      },
      "face_up": false
    },
    {
      "id": "card03",
      "index": 2,
      "y": 0,
      "x": 0,
      "z": 0.03,
      "front": {
        "metalness": "/textures/deck_nature/power01_rough.png",
        "texture": "/textures/deck_nature/power01.png"
      },
      "back": {
        "texture": "/textures/deck_nature/backside_01.png",
        "metalness": "/textures/deck_nature/backside_01_rough.png",
      },
      "face_up": false
    },

    {
      "id": "card04",
      "index": 4,
      "y": 0,
      "x": 0,
      "z": 0.03,
      "front": {
        "metalness": "/textures/deck_nature/trust01_rough.png",
        "texture": "/textures/deck_nature/trust01.png",
      },
      "back": {
        "texture": "/textures/deck_nature/backside_01.png",
        "metalness": "/textures/deck_nature/backside_01_rough.png",
      },
      "face_up": false
    },
    {
      "id": "card05",
      "index": 4,
      "y": 0,
      "x": 0,
      "z": 0.03,
      "front": {
        "metalness": "/textures/deck_nature/ego01_rough.png",
        "texture": "/textures/deck_nature/ego01.png"
      },
      "back": {
        "texture": "/textures/deck_nature/backside_01.png",
        "metalness": "/textures/deck_nature/backside_01_rough.png",
      },
      "face_up": false
    },
    {
      "id": "card06",
      "index": 5,
      "y": 0,
      "x": 0,
      "z": 0.03,
      "front": {
        "metalness": "/textures/deck_nature/power01_rough.png",
        "texture": "/textures/deck_nature/power01.png"
      },
      "back": {
        // "texture": "/textures/deck_nature/greysteps.png",
        "texture": "/textures/deck_nature/backside_01.png",
        "metalness": "/textures/deck_nature/backside_01_rough.png",
      },
      "face_up": false
    },

    // {
    //   "id": "card07",
    //   "index": 6,
    //   "y": 0,
    //   "x": 0,
    //   "z": 0.03,
    //   "front": {
    //     "metalness": "/textures/deck_nature/trust01_rough.png",
    //     "texture": "/textures/deck_nature/trust01.png",
    //   },
    //   "back": {
    //     "texture": "/textures/deck_nature/backside_01.png",
    //     "metalness": "/textures/deck_nature/backside_01_rough.png",
    //   },
    //   "face_up": false
    // },
    // {
    //   "id": "card08",
    //   "index": 7,
    //   "y": 0,
    //   "x": 0,
    //   "z": 0.03,
    //   "front": {
    //     "metalness": "/textures/deck_nature/ego01_rough.png",
    //     "texture": "/textures/deck_nature/ego01.png"
    //   },
    //   "back": {
    //     "texture": "/textures/deck_nature/backside_01.png",
    //     "metalness": "/textures/deck_nature/backside_01_rough.png",
    //   },
    //   "face_up": false
    // },
    // {
    //   "id": "card09",
    //   "index": 8,
    //   "y": 0,
    //   "x": 0,
    //   "z": 0.03,
    //   "front": {
    //     "metalness": "/textures/deck_nature/power01_rough.png",
    //     "texture": "/textures/deck_nature/power01.png"
    //   },
    //   "back": {
    //     "texture": "/textures/deck_nature/backside_01.png",
    //     "metalness": "/textures/deck_nature/backside_01_rough.png",
    //   },
    //   "face_up": false
    // },

    // {
    //   "id": "card10",
    //   "index": 9,
    //   "y": 0,
    //   "x": 0,
    //   "z": 0.03,
    //   "front": {
    //     "metalness": "/textures/deck_nature/trust01_rough.png",
    //     "texture": "/textures/deck_nature/trust01.png",
    //   },
    //   "back": {
    //     "texture": "/textures/deck_nature/backside_01.png",
    //     "metalness": "/textures/deck_nature/backside_01_rough.png",
    //   },
    //   "face_up": false
    // },
    // {
    //   "id": "card11",
    //   "index": 10,
    //   "y": 0,
    //   "x": 0,
    //   "z": 0.03,
    //   "front": {
    //     "metalness": "/textures/deck_nature/ego01_rough.png",
    //     "texture": "/textures/deck_nature/ego01.png"
    //   },
    //   "back": {
    //     "texture": "/textures/deck_nature/backside_01.png",
    //     "metalness": "/textures/deck_nature/backside_01_rough.png",
    //   },
    //   "face_up": false
    // },
    // {
    //   "id": "card12",
    //   "index": 11,
    //   "y": 0,
    //   "x": 0,
    //   "z": 0.03,
    //   "front": {
    //     "metalness": "/textures/deck_nature/power01_rough.png",
    //     "texture": "/textures/deck_nature/power01.png"
    //   },
    //   "back": {
    //     "texture": "/textures/deck_nature/backside_01.png",
    //     "metalness": "/textures/deck_nature/backside_01_rough.png",
    //   },
    //   "face_up": false
    // },

    // {
    //   "id": "card13",
    //   "index": 12,
    //   "y": 0,
    //   "x": 0,
    //   "z": 0.03,
    //   "front": {
    //     "metalness": "/textures/deck_nature/trust01_rough.png",
    //     "texture": "/textures/deck_nature/trust01.png",
    //   },
    //   "back": {
    //     "texture": "/textures/deck_nature/backside_01.png",
    //     "metalness": "/textures/deck_nature/backside_01_rough.png",
    //   },
    //   "face_up": false
    // },
    // {
    //   "id": "card14",
    //   "index": 13,
    //   "y": 0,
    //   "x": 0,
    //   "z": 0.03,
    //   "front": {
    //     "metalness": "/textures/deck_nature/ego01_rough.png",
    //     "texture": "/textures/deck_nature/ego01.png"
    //   },
    //   "back": {
    //     "texture": "/textures/deck_nature/backside_01.png",
    //     "metalness": "/textures/deck_nature/backside_01_rough.png",
    //   },
    //   "face_up": false
    // },
    // {
    //   "id": "card15",
    //   "index": 14,
    //   "y": 0,
    //   "x": 0,
    //   "z": 0.03,
    //   "front": {
    //     "metalness": "/textures/deck_nature/power01_rough.png",
    //     "texture": "/textures/deck_nature/power01.png"
    //   },
    //   "back": {
    //     "texture": "/textures/deck_nature/backside_01.png",
    //     "metalness": "/textures/deck_nature/backside_01_rough.png",
    //   },
    //   "face_up": false
    // },

    // {
    //   "id": "card16",
    //   "index": 15,
    //   "y": 0,
    //   "x": 0,
    //   "z": 0.03,
    //   "front": {
    //     "metalness": "/textures/deck_nature/trust01_rough.png",
    //     "texture": "/textures/deck_nature/trust01.png",
    //   },
    //   "back": {
    //     "texture": "/textures/deck_nature/backside_01.png",
    //     "metalness": "/textures/deck_nature/backside_01_rough.png",
    //   },
    //   "face_up": false
    // },
    // {
    //   "id": "card17",
    //   "index": 16,
    //   "y": 0,
    //   "x": 0,
    //   "z": 0.03,
    //   "front": {
    //     "metalness": "/textures/deck_nature/ego01_rough.png",
    //     "texture": "/textures/deck_nature/ego01.png"
    //   },
    //   "back": {
    //     "texture": "/textures/deck_nature/backside_01.png",
    //     "metalness": "/textures/deck_nature/backside_01_rough.png",
    //   },
    //   "face_up": false
    // },
    // {
    //   "id": "card18",
    //   "index": 17,
    //   "y": 0,
    //   "x": 0,
    //   "z": 0.03,
    //   "front": {
    //     "metalness": "/textures/deck_nature/power01_rough.png",
    //     "texture": "/textures/deck_nature/power01.png"
    //   },
    //   "back": {
    //     "texture": "/textures/deck_nature/backside_01.png",
    //     "metalness": "/textures/deck_nature/backside_01_rough.png",
    //   },
    //   "face_up": false
    // },

    // {
    //   "id": "card19",
    //   "index": 18,
    //   "y": 0,
    //   "x": 0,
    //   "z": 0.03,
    //   "front": {
    //     "metalness": "/textures/deck_nature/trust01_rough.png",
    //     "texture": "/textures/deck_nature/trust01.png",
    //   },
    //   "back": {
    //     "texture": "/textures/deck_nature/backside_01.png",
    //     "metalness": "/textures/deck_nature/backside_01_rough.png",
    //   },
    //   "face_up": false
    // },
    // {
    //   "id": "card20",
    //   "index": 19,
    //   "y": 0,
    //   "x": 0,
    //   "z": 0.03,
    //   "front": {
    //     "metalness": "/textures/deck_nature/ego01_rough.png",
    //     "texture": "/textures/deck_nature/ego01.png"
    //   },
    //   "back": {
    //     "texture": "/textures/deck_nature/backside_01.png",
    //     "metalness": "/textures/deck_nature/backside_01_rough.png",
    //   },
    //   "face_up": false
    // },
    // {
    //   "id": "card21",
    //   "index": 20,
    //   "y": 0,
    //   "x": 0,
    //   "z": 0.03,
    //   "front": {
    //     "metalness": "/textures/deck_nature/power01_rough.png",
    //     "texture": "/textures/deck_nature/power01.png"
    //   },
    //   "back": {
    //     "texture": "/textures/deck_nature/backside_01.png",
    //     "metalness": "/textures/deck_nature/backside_01_rough.png",
    //   },
    //   "face_up": false
    // },

    // {
    //   "id": "card22",
    //   "index": 21,
    //   "y": 0,
    //   "x": 0,
    //   "z": 0.03,
    //   "front": {
    //     "metalness": "/textures/deck_nature/trust01_rough.png",
    //     "texture": "/textures/deck_nature/trust01.png",
    //   },
    //   "back": {
    //     "texture": "/textures/deck_nature/backside_01.png",
    //     "metalness": "/textures/deck_nature/backside_01_rough.png",
    //   },
    //   "face_up": false
    // },
    // {
    //   "id": "card23",
    //   "index": 22,
    //   "y": 0,
    //   "x": 0,
    //   "z": 0.03,
    //   "front": {
    //     "metalness": "/textures/deck_nature/ego01_rough.png",
    //     "texture": "/textures/deck_nature/ego01.png"
    //   },
    //   "back": {
    //     "texture": "/textures/deck_nature/backside_01.png",
    //     "metalness": "/textures/deck_nature/backside_01_rough.png",
    //   },
    //   "face_up": false
    // },
    // {
    //   "id": "card24",
    //   "index": 23,
    //   "y": 0,
    //   "x": 0,
    //   "z": 0.03,
    //   "front": {
    //     "metalness": "/textures/deck_nature/power01_rough.png",
    //     "texture": "/textures/deck_nature/power01.png"
    //   },
    //   "back": {
    //     "texture": "/textures/deck_nature/backside_01.png",
    //     "metalness": "/textures/deck_nature/backside_01_rough.png",
    //   },
    //   "face_up": false
    // },

    // {
    //   "id": "card25",
    //   "index": 24,
    //   "y": 0,
    //   "x": 0,
    //   "z": 0.03,
    //   "front": {
    //     "metalness": "/textures/deck_nature/trust01_rough.png",
    //     "texture": "/textures/deck_nature/trust01.png",
    //   },
    //   "back": {
    //     "texture": "/textures/deck_nature/backside_01.png",
    //     "metalness": "/textures/deck_nature/backside_01_rough.png",
    //   },
    //   "face_up": false
    // },
    // {
    //   "id": "card26",
    //   "index": 25,
    //   "y": 0,
    //   "x": 0,
    //   "z": 0.03,
    //   "front": {
    //     "metalness": "/textures/deck_nature/ego01_rough.png",
    //     "texture": "/textures/deck_nature/ego01.png"
    //   },
    //   "back": {
    //     "texture": "/textures/deck_nature/backside_01.png",
    //     "metalness": "/textures/deck_nature/backside_01_rough.png",
    //   },
    //   "face_up": false
    // },
    // {
    //   "id": "card27",
    //   "index": 26,
    //   "y": 0,
    //   "x": 0,
    //   "z": 0.03,
    //   "front": {
    //     "metalness": "/textures/deck_nature/power01_rough.png",
    //     "texture": "/textures/deck_nature/power01.png"
    //   },
    //   "back": {
    //     "texture": "/textures/deck_nature/backside_01.png",
    //     "metalness": "/textures/deck_nature/backside_01_rough.png",
    //   },
    //   "face_up": false
    // },

    // {
    //   "id": "card28",
    //   "index": 27,
    //   "y": 0,
    //   "x": 0,
    //   "z": 0.03,
    //   "front": {
    //     "metalness": "/textures/deck_nature/trust01_rough.png",
    //     "texture": "/textures/deck_nature/trust01.png",
    //   },
    //   "back": {
    //     "texture": "/textures/deck_nature/backside_01.png",
    //     "metalness": "/textures/deck_nature/backside_01_rough.png",
    //   },
    //   "face_up": false
    // },
    // {
    //   "id": "card29",
    //   "index": 28,
    //   "y": 0,
    //   "x": 0,
    //   "z": 0.03,
    //   "front": {
    //     "metalness": "/textures/deck_nature/ego01_rough.png",
    //     "texture": "/textures/deck_nature/ego01.png"
    //   },
    //   "back": {
    //     "texture": "/textures/deck_nature/backside_01.png",
    //     "metalness": "/textures/deck_nature/backside_01_rough.png",
    //   },
    //   "face_up": false
    // },
    // {
    //   "id": "card30",
    //   "index": 29,
    //   "y": 0,
    //   "x": 0,
    //   "z": 0.03,
    //   "front": {
    //     "metalness": "/textures/deck_nature/power01_rough.png",
    //     "texture": "/textures/deck_nature/power01.png"
    //   },
    //   "back": {
    //     "texture": "/textures/deck_nature/backside_01.png",
    //     "metalness": "/textures/deck_nature/backside_01_rough.png",
    //   },
    //   "face_up": false
    // },



  ]
}

